declare const jQuery: any;
const $ = jQuery;

const initCustomSelect: Function = window["iw"].initCustomSelect;

export function initCF7(): void
{
    const $wraps = $(".wpcf7");
    if ($wraps.length === 0)
    {
        return;
    }
    $wraps.each(function () {
        const $wrap = $(this);
        initCF7CustomSelects($wrap);
        initCF7ConditionalInputs($wrap);
    });
}

function initCF7CustomSelects($wrap): void
{
    $wrap.find("select").each(function () {
        initCustomSelect(this);
    });
}

function initCF7ConditionalInputs($wrap): void
{
    $wrap.find(`[data-show-if]`).each(function () {
        const $inputWrap = $(this);
        const [ inputName, value ] = $inputWrap.attr("data-show-if").split(/\s*\=\s*/);
        const $input = $wrap.find(`[name="${inputName}"]`);
        if ($input.length === 0)
        {
            console.error(`Input with name '${name}' not found`);
            return;
        }
        const update = () => {
            if ($input.val() === value)
            {
                $inputWrap.show();
            }
            else
            {
                $inputWrap.hide();
            }
        };
        update();
        $(window).on("load", function () {
            setTimeout(update, 80);
        });
        $input.on("change input", update);
    });
}
